import React from 'react'

const SupportCall = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 22 22"
      fill="none"
    >
      <g clipPath="url(#clip0_2389_59369)">
        <path
          d="M6.495 4.58333C6.55 5.39917 6.6875 6.19667 6.9075 6.9575L5.8075 8.0575C5.43167 6.9575 5.19333 5.79333 5.11083 4.58333H6.495ZM15.5333 15.6017C16.3125 15.8217 17.11 15.9592 17.9167 16.0142V17.38C16.7067 17.2975 15.5425 17.0592 14.4333 16.6925L15.5333 15.6017ZM7.375 2.75H4.16667C3.6625 2.75 3.25 3.1625 3.25 3.66667C3.25 12.2742 10.2258 19.25 18.8333 19.25C19.3375 19.25 19.75 18.8375 19.75 18.3333V15.1342C19.75 14.63 19.3375 14.2175 18.8333 14.2175C17.6967 14.2175 16.5875 14.0342 15.5608 13.695C15.4692 13.6583 15.3683 13.6492 15.2767 13.6492C15.0383 13.6492 14.8092 13.7408 14.6258 13.915L12.6092 15.9317C10.015 14.6025 7.88833 12.485 6.56833 9.89083L8.585 7.87417C8.84167 7.6175 8.915 7.26 8.81417 6.93917C8.475 5.9125 8.29167 4.8125 8.29167 3.66667C8.29167 3.1625 7.87917 2.75 7.375 2.75Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2389_59369">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SupportCall
